export default [
    {
		path: "/clinicalcases/list/:clinicalcaseid?",
		component: () => import("../views/ClinicalCases/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
